import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const DashboardComponent = styled.div`
  background: #1d1d1b;
  height: 100%;
  display: flex;
  flex-direction: column;

  .sidebar {
    width: 15%;
    background: #1d1d1b;
    padding: 20px;
    color: white;
    flex-shrink: 0;
    position: fixed;
    left: 0;
    height: 100%;
  }

  .containerImg {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    @media (max-width: ${screenSizes.tablet}) {
      display: none;
    }
  }

  .button {
    border: 1px solid #242323;
    border-radius: 10px;
    background: #242323;
    color: white;
    padding: 10px 20px;
    cursor: pointer;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    font-size: 16px;
  }

  .button:active {
    box-shadow: none;
    transform: translateY(2px);
  }

  .spinner {
    width: 100px;
    height: 100px;
    border-width: 10px;
    border-style: solid;
    border-color: #f3f3f3;
    border-top-color: #242323;
    border-radius: 50%;
    clip-path: circle(50%);
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .inputs {
    border-radius: 10px;
    border: 1px solid #242323;
    padding: 5px;
  }

  .tooltipContainer {
    border: 1px solid #ccc;
    background-color: white;
    padding: 5px;
  }

  .labels {
    margin-right: 8px;
  }

  .containerSpinner {
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 30px;
    align-items: center;
    height: 80vh;
  }

  .profile-img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 1px 2px 10px rgb(255 255 255 / 30%);
    border: 2px solid rgb(65, 65, 65);
    object-fit: cover;
    object-position: center;
  }

  .menuList {
    list-style-type: none;
    padding: 0;
    text-align: left;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    li {
      margin-bottom: 15px;
      text-align: center;
      width: 100%;

      a {
        display: block;
        padding: 10px;
        background-color: #444;
        border-radius: 15px;
        color: white;
        text-decoration: none;
        font-weight: 500;
        white-space: nowrap;

        &:hover {
          background-color: #666;
        }

        &.activePerfil {
          color: #10d8b4;
        }

        &.activeGrupos {
          color: #009700;
        }

        &.activeCrecer {
          color: #fc9133;
        }

        &.activeEventos {
          color: #00d1a4;
        }

        &.activeEncuestas {
          color: #00c9d0;
        }

        &.activeExperiencia {
          color: #10d8b4;
        }

        &.activePerfil,
        &.activeGrupos,
        &.activeCrecer,
        &.activeEventos,
        &.activeEncuestas,
        &.activeExperiencia {
          background-color: white;
        }
      }

      .icon {
        display: none; /* Oculta el icono en modo escritorio */
      }

      .text {
        display: block; /* Muestra el texto en modo escritorio */
      }
    }
  }

  @media (max-width: ${screenSizes.tablet}) {
    .sidebar {
      width: 100%;
      height: 60px;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      border-radius: 15px 15px 0px 0px;
      background-color: #262421;
      z-index: 1000;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 20px;
    }

    .menuList {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      width: 100%;
      padding: 0;
      margin: 0;
    }

    .menuList li {
      margin-bottom: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .menuList li a {
      padding: 5px;
      text-align: center;
      background: none;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .menuList li .icon {
      display: block; /* Muestra el icono en modo móvil */
      font-size: 24px; /* Ajusta el tamaño del icono según sea necesario */
      width: 40px; /* Ajusta el tamaño del círculo */
      height: 40px; /* Ajusta el tamaño del círculo */
      border-radius: 50%;
      background: linear-gradient(45deg, #ff0066, #ffcc00); /* Degradado lineal */
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 5px;
    }

    .menuList li .text {
      display: none; /* Oculta el texto en modo móvil */
    }
  }

  /* Estilos para el modal */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    width: 80%;
    max-width: 600px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
    max-height: 80vh; /* Alto máximo para el contenido */
  }

  /* Agregar scroll cuando la lista sea grande */
  .modal-list {
    max-height: 400px; /* Limitar la altura máxima */
    overflow-y: auto; /* Mostrar scroll si el contenido es grande */
    padding-right: 10px; /* Para que no se superponga el contenido con la barra de desplazamiento */
  }

  button.close-btn {
    padding: 8px 16px;
    background-color: #3498db;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
  }

  button.close-btn:hover {
    background-color: #2980b9;
  }

  /* Estilo para la lista de detalles */
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 15px;
  }

  li p {
    margin: 5px 0;
  }

  li strong {
    font-weight: bold;
  }
`;
